import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Button, CircularProgress } from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { removeProductRawFromDemandAPI, addProductRawToDemandAPI } from 'api/OmsOrdermgmtWebServices';
import { updateProductObj } from 'store/slice/PharmaSlice';


export default function RawDemandMgmt() {
    const dispatch = useDispatch();
    const { apiInProgress } = useSelector((state) => state.headerslice);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const { productrawList } = useSelector((state) => state.pharmaslice.productrawDashboard);
    const { productrawObj } = useSelector((state) => state.pharmaslice.productrawDashboard);

    useEffect(() => {
    }, [productrawList, productrawObj])

    const addproductRawToDemand = () => {
        dispatch(setApiInProgress(true));
        addProductRawToDemandAPI({ "productId": productObj.id }, addproductRawToDemandSuccess, apiFailure)
    }
    const addproductRawToDemandSuccess = (responseObj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProductObj(responseObj.productInfo))
    }

    const removeProductRawFromDemand = () => {
        dispatch(setApiInProgress(true));
        removeProductRawFromDemandAPI({ "productId": productObj.id }, removeProductRawFromDemandSuccess, apiFailure)
    }
    const removeProductRawFromDemandSuccess = (responseObj) => {
        dispatch(setApiInProgress(false));
        dispatch(updateProductObj(responseObj.productInfo))
    }
    const apiFailure = () => {
        dispatch(setApiInProgress(false));
    }

    return (
        <Grid container direction="row" justifyContent="flex-end" sx={{ paddingRight: 2 }} >
            {apiInProgress ? <CircularProgress /> :
                <>
                    <Grid item sx={{ paddingRight: 1 }}>
                        <Button variant="outlined" onClick={() => addproductRawToDemand()} disabled={productrawList.length > 0 && productObj.rmstatus !== "DEMANDED" ? false : true}>Add to Demand</Button>
                    </Grid>
                    <Grid item><Button variant="outlined" onClick={() => removeProductRawFromDemand()} disabled={productObj.rmstatus === "DEMANDED" ? false : true}>Remove from Demand</Button></Grid>
                </>
            }
        </Grid>

    )
}